import axios  from "./axiosInstance";

const baseUrl = process.env.REACT_APP_API_URL || "http://localhost:5001/api";

export default class AxiosService {
  static get(
    endpoint,
    params = {},
    data = {},
    customHeaders = {},
    isAuth = true
  ) {
    var url = baseUrl + endpoint;

    var defaultHeaders = {
      "content-type": "application/json",
      Accept: "application/json",
    };

    // if (isAuth) {
    //   var token = sessionStorage.getItem("token");
    //   defaultHeaders["Authorization"] = "Bearer " + token;
    // }

    defaultHeaders = { ...defaultHeaders, ...customHeaders };

    var config = {
      method: "get",
      url: url,
      params: params || {},
      headers: defaultHeaders,
    };

    return new Promise(function (resolve, reject) {
      axios(config)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static post(
    endpoint,
    params = {},
    data = {},
    customHeaders = {},
    isAuth = true
  ) {
    var url = baseUrl + endpoint;

    let defaultHeaders = {
      Accept: "application/json",
    };

    if (!(data instanceof FormData)) {
      defaultHeaders["Content-Type"] = "application/json";
    }

    // if (isAuth) {
    //   var token = sessionStorage.getItem("token");
    //   defaultHeaders["Authorization"] = "Bearer " + token;
    // }

    defaultHeaders = { ...defaultHeaders, ...customHeaders };

    var config = {
      method: "post",
      url: url,
      params: params || {},
      data: data,
      headers: defaultHeaders,
    };

    return new Promise(function (resolve, reject) {
      axios(config)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static put(
    endpoint,
    params = {},
    data = {},
    customHeaders = {},
    isAuth = true
  ) {
    var url = baseUrl + endpoint;

    var defaultHeaders = {
      "content-type": "application/json",
      Accept: "application/json",
    };

    // if (isAuth) {
    //   var token = sessionStorage.getItem("token");
    //   defaultHeaders["Authorization"] = "Bearer " + token;
    // }

    defaultHeaders = { ...defaultHeaders, ...customHeaders };

    var config = {
      method: "put",
      url: url,
      params: params || {},
      data: data,
      headers: defaultHeaders,
    };

    return new Promise(function (resolve, reject) {
      axios(config)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static patch(
    endpoint,
    params = {},
    data = {},
    customHeaders = {},
    isAuth = true
  ) {
    var url = baseUrl + endpoint;

    var defaultHeaders = {
      "content-type": "application/json",
      Accept: "application/json",
    };

    // if (isAuth) {
    //   var token = sessionStorage.getItem("token");
    //   defaultHeaders["Authorization"] = "Bearer " + token;
    // }

    defaultHeaders = { ...defaultHeaders, ...customHeaders };

    var config = {
      method: "patch",
      url: url,
      params: params || {},
      data: data,
      headers: defaultHeaders,
    };

    return new Promise(function (resolve, reject) {
      axios(config)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static delete(
    endpoint,
    params = {},
    data = {},
    customHeaders = {},
    isAuth = true
  ) {
    var url = baseUrl + endpoint;

    var defaultHeaders = {
      "content-type": "application/json",
      Accept: "application/json",
    };

    // if (isAuth) {
    //   var token = sessionStorage.getItem("token");
    //   defaultHeaders["Authorization"] = "Bearer " + token;
    // }

    defaultHeaders = { ...defaultHeaders, ...customHeaders };

    var config = {
      method: "delete",
      url: url,
      params: params || {},
      data: data,
      headers: defaultHeaders,
    };

    return new Promise(function (resolve, reject) {
      axios(config)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}
